import React from 'react'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Article from '../Article';

const CustomSlider = ({ containerObject }) => {
    var content = containerObject;
    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: content?.attributes?.superLargeDesktop == "1" ? 1 : content?.attributes?.superLargeDesktop == "2" ? 2 : content?.attributes?.superLargeDesktop == "3" ? 3 : content?.attributes?.superLargeDesktop == "4" ? 4 : content?.attributes?.superLargeDesktop == "5" ? 5 : 1
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: content?.attributes?.desktop == "1" ? 1 : content?.attributes?.desktop == "2" ? 2 : content?.attributes?.desktop == "3" ? 3 : content?.attributes?.desktop == "4" ? 4 : content?.attributes?.desktop == "5" ? 5 : 1
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: content?.attributes?.tablet == "1" ? 1 : content?.attributes?.tablet == "2" ? 2 : content?.attributes?.tablet == "3" ? 3 : content?.attributes?.tablet == "4" ? 4 : content?.attributes?.tablet == "5" ? 5 : 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: content?.attributes?.mobile == "1" ? 1 : content?.attributes?.mobile == "2" ? 2 : content?.attributes?.mobile == "3" ? 3 : content?.attributes?.mobile == "4" ? 4 : content?.attributes?.mobile == "5" ? 5 : 1
        }
    }




    return (
        <>
            <div style={{
                backgroundColor: containerObject.attributes.backgroundColor ? containerObject.attributes.backgroundColor : "",
                backgroundImage: containerObject.attributes.backgroundImageUrl ? `url(${containerObject.attributes.backgroundImageUrl})` : ""
            }}>
                {containerObject.attributes.backgroundVideoUrl ?
                    <iframe src={`${containerObject.attributes.backgroundVideoUrl}`} style={{ width: '100%', backgroundRepeat: 'no-repeat' }} className='img-fluid' /> : ""}
                <Carousel
                    swipeable={content.attributes.swipeable == "true" ? true : false}
                    draggable={content.attributes.draggable == "true" ? true : false}
                    showDots={content.attributes.showDots == "true" ? true : false}
                    responsive={responsive}
                    ssr // means to render carousel on server-side.
                    infinite={content.attributes.infinite == "true" ? true : false}
                    autoPlay={content.attributes.autoPlay == "true" ? true : false}
					autoPlaySpeed={content?.attributes?.autoPlaySpeed ? content?.attributes?.autoPlaySpeed : "3000"}
                    keyBoardControl={content.attributes.keyBoardControl == "true" ? true : false}
                    //customTransition="all .5"
                    //transitionDuration={500}
                    //containerClass="carousel-container"
                    removeArrowOnDeviceType={[""]}
                    deviceType="desktop"
                    // dotListClass="custom-dot-list-style"
                    itemClass="carousel-item-padding-40-px"
                >
                    {content.customSliderContainer.map((info) => {
                        return (
                            <>
                                <Article articleObj={info}></Article>
                                {/* <img src={info.attributes.imageUrl} className="slide" alt="mainImage"/> */}
                            </>
                        )
                    })}
                </Carousel>
            </div>
        </>
    )

}

export default CustomSlider